import {
    filterContactPlanFamilyTypeMembers,
    getAdultNames, getAdultTitles, getChildNameFromCommsPlan, getFormTableColumnForDisplay,
    getFormTableColumnsForDisplay,
    getTableColumnStyles
} from "root/DataFunctions/CommunicationsPlanDataFns";

import {FamilyTypes} from "root/DataFunctions/Constants";

export const outputAgencyDetails = ( pdf, contact, formFields ) =>
{
    if ( contact !== undefined )
    {
        const headers = [{title: 'Professional Involvement', detail: '' }];

        if ( formFields.other_agency_yes_no.bool === true )
        {
            const columnStyles = getTableColumnStyles ( pdf.getPrintWidth() , .55, .45 ) ;

            const data = getFormTableColumnsForDisplay( formFields, ['other_agency_yes_no', 'agency_name', 'agency_email_address', 'agency_worker_name', 'send_to_agency_flag_yes_no'] );

            pdf.outputTable(headers, data, {columnStyles: columnStyles, theme: 'striped', showHead: false, fontSize: 12, fontName: 'helvetica', cellPadding: 5});

        }
        else
        {
            const columnStyles = getTableColumnStyles ( pdf.getPrintWidth() ,.65, .35 ) ;

            const data = getFormTableColumnsForDisplay( formFields, ['other_agency_yes_no'] );

            pdf.outputTable(headers, data, {columnStyles: columnStyles, theme: 'striped', showHead: false, fontSize: 12, fontName: 'helvetica', cellPadding: 5});
        }
    }
}

export const outputChildDetails = ( pdf, contact, formFields  ) =>
{
    if ( contact !== undefined )
    {
        const headers = [{title: 'Details of parties involved', detail: '' }];

        const columnStyles = getTableColumnStyles ( pdf.getPrintWidth() , .55, .45 ) ;

        const adultName = getAdultNames ( filterContactPlanFamilyTypeMembers( FamilyTypes.BIRTH, contact.connections ));
        const adultTitles = getAdultTitles ( filterContactPlanFamilyTypeMembers( FamilyTypes.BIRTH,  contact.connections ));

        const childName = getChildNameFromCommsPlan( contact )

        const data = [
            getFormTableColumnForDisplay(formFields, 'letterbox_reference'),
            [`Child's Birth Name`, childName ],
            [`Child's Date Of Birth`, contact.dob ],
            [`Birth Relative's Names`, adultName ],
            [`Relationship to Child`, adultTitles ],
            [`Date Of Agreement`, contact.agreement_date ],
        ];

        pdf.outputTable(headers, data, {columnStyles: columnStyles, theme: 'striped', showHead: false, fontSize: 11, fontName: 'helvetica', cellPadding: 5});
    }
}

export const outputAdopterPlanDetails = ( pdf, contact, formFields ) =>
{
    if ( contact !== undefined )
    {
        const headers = [{title: 'Communication from Child / Adopters', detail: '' }];

        if ( formFields.adopters_can_send_letters.bool === true )
        {
            const columnStyles = getTableColumnStyles ( pdf.getPrintWidth() , .55, .45 ) ;

            const data = getFormTableColumnsForDisplay( formFields, ['adopters_can_send_letters',
                                                                           'adopters_can_send_photos',
                                                                           'adopter_artwork_rules',
                                                                           'adopter_christmas_card_rules',
                                                                           'adopter_birthday_card_rules',
                                                                           'adopter_message_rules'] );

            pdf.outputTable(headers, data, {columnStyles: columnStyles, theme: 'striped', showHead: false, fontSize: 12, fontName: 'helvetica', cellPadding: 5});

        }
        else
        {
            const columnStyles = getTableColumnStyles ( pdf.getPrintWidth() ,.65, .35 ) ;

            const data = getFormTableColumnsForDisplay( formFields, ['adopters_can_send_letters', 'adopter_message_rules'] );

            pdf.outputTable(headers, data, {columnStyles: columnStyles, theme: 'striped', showHead: false, fontSize: 12, fontName: 'helvetica', cellPadding: 5});
        }
    }
}

export const outputBirthRelativePlanDetails = ( pdf, contact, formFields ) =>
{
    if ( contact !== undefined )
    {
        const headers = [{title: 'Communication from Child / Adopters', detail: '' }];

        if ( formFields.birth_relatives_can_send_letters.bool === true )
        {
            const columnStyles = getTableColumnStyles ( pdf.getPrintWidth() , .55, .45 ) ;

            const data = getFormTableColumnsForDisplay( formFields, ['birth_relatives_can_send_letters',
                'birth_relatives_can_send_photos',
                'birth_relative_artwork_rules',
                'birth_relative_christmas_card_rules',
                'birth_relative_birthday_card_rules',
                'birth_relative_message_rules'] );

            pdf.outputTable(headers, data, {columnStyles: columnStyles, theme: 'striped', showHead: false, fontSize: 12, fontName: 'helvetica', cellPadding: 5});

        }
        else
        {
            const columnStyles = getTableColumnStyles ( pdf.getPrintWidth() ,.65, .35 ) ;

            const data = getFormTableColumnsForDisplay( formFields, ['birth_relatives_can_send_letters'] );

            pdf.outputTable(headers, data, {columnStyles: columnStyles, theme: 'striped', showHead: false, fontSize: 12, fontName: 'helvetica', cellPadding: 5});
        }
    }
}